<template>
    <div>
        <button class="btn -clear" @click="openFollowersModal">
            <slot></slot>
        </button>
        <followers-modal v-if="showModal" @close-modal="closeModal" :authUserId="authUserId" :userName="userName" :followers="followers"></followers-modal>
    </div>
</template>

<script>
    import FollowersModal from './modals/Followers';
    export default {
        props: [
          'userName',
          'userId',
          'authUserId'
        ],
        data() {
            return {
                showModal: false,
                followers: []
            }
        },
        methods: {
            openFollowersModal() {
                EventBus.$emit('loading-show');
                axios.get('/ajax/usuario/' + this.userId + '/seguidores')
                    .then(({data}) => {
                        if (data.status == 'success') {
                          this.followers = data.followers;
                          this.showModal = true;
                        }
                    })
                    .then(() => EventBus.$emit('loading-hide'));
            },
            closeModal() {
                this.showModal = false;
            }
        },
        components: {
            FollowersModal
        }
    }
</script>
